/**
  * 加密处理
  * @param params
  * @returns {any}
  */
  // function encryption(params){
  //   let {
  //     data,
  //     type,
  //     param,
  //     key
  //   } = params;
  //   const result = JSON.parse(JSON.stringify(data));
  //   if (type === 'Base64') {
  //     param.forEach(ele => {
  //       result[ele] = btoa(result[ele])
  //     })
  //   } else {
  //     param.forEach(ele => {
  //       let data = result[ele];
  //       key = CryptoJS.enc.Latin1.parse(key);
  //       let iv = key;
  //       // 加密
  //       let encrypted = CryptoJS.AES.encrypt(
  //         data,
  //         key, {
  //           iv: iv,
  //           mode: CryptoJS.mode.CBC,
  //           padding: CryptoJS.pad.ZeroPadding
  //         });
  //       result[ele] = encrypted.toString()
  //     })
  //   }
  //   return result
  // }

  // 自适应
  function resize() {
    var width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

    var fullHeight = window.screen.availHeight;
    var fullWidth = window.screen.availWidth;

    var coverHeightGlobal = (fullHeight / fullWidth) * width;

    // 获取窗口的高度与宽度(不包含工具栏与滚动条):
    coverHeightGlobal = window.innerHeight;
    console.log('util.js:', coverHeightGlobal);
    return coverHeightGlobal;
  }

  //base64转码（压缩完成后的图片为base64编码，这个方法可以将base64编码转回file文件）
  function dataURLtoFile(dataurl) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], { type: mime }); 
  }

//压缩图片：比例压缩
export function compressImg(path) {
  return new Promise(function (resolve, reject) {
      var img = new Image();
      img.src = path;
      // console.log('img:', img);
      img.onload = function () {
        //默认按比例压缩
        var w = this.width,
            h = this.height,
            scale = w / h;
        var quality = 0.2; //默认图片质量0.7
        //生成canvas
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var base64;
        // 创建属性节点
        canvas.setAttribute("width", w);
        canvas.setAttribute("height", h);
        ctx.drawImage(this, 0, 0, w, h);
        var base64 = canvas.toDataURL('image/jpeg', quality);
        // 回调函数返回file的值（将base64编码转成file）
        // files = dataURLtoFile(base64); //如果后台接收类型为base64的话这一步可以省略
        // console.log('base64:', base64);
        resolve(base64)
      };
  })
}

// 将base64转换为blob
function convertBase64UrlToBlob(urlData) {
  var arr = urlData.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

// 压缩图片path:制定高宽压缩
export function compressImage(path, config) {
  return new Promise((resolve, reject) => {
    var img = new Image()
    img.src = path
    img.onload = function() {
      var that = this
      var w = that.width
      var h = that.height
      var scale = w / h
      w = config.width || config.height * scale
      h = config.height || config.width / scale
      var quality = 0.7 // 默认图片质量为0.7
      // 生成canvas
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')
      // 创建属性节点
      var anw = document.createAttribute('width')
      anw.nodeValue = w
      var anh = document.createAttribute('height')
      anh.nodeValue = h
      canvas.setAttributeNode(anw)
      canvas.setAttributeNode(anh)
      ctx.drawImage(that, 0, 0, w, h)
      if (config.quality && config.quality <= 1 && config.quality > 0) {
        quality = config.quality
      }
      var base64 = canvas.toDataURL('image/*', quality)
      // console.log('base64:', base64);
      var blob = convertBase64UrlToBlob(base64)
      // 回调函数返回base64的值，也可根据自己的需求返回blob的值
      resolve(base64)
      // resolve(blob)
    }
  })
}


// 根据url获取图片 base64
export function imgUrlToFile(url) {
  var imgLink = url;
  var tempImage = new Image();
  tempImage.src = imgLink;
  //如果图片url是网络url，要加下一句代码
  // tempImage.crossOrigin = "*";
  var base64 = getBase64Image(tempImage);
  // console.log('base64:', base64);
  var imgblob = base64toBlob(base64);
  var filename = getFileName(url);
  var blobReturn = blobToFile(imgblob, filename);
  console.log('blobReturn:', blobReturn);
  return blobReturn;
}

function getBase64Image(img) {
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, img.width, img.height);
  var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
  var dataURL = canvas.toDataURL("image/" + ext);
  return dataURL;
}

function base64toBlob(base64) {
  let arr = base64.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

function blobToFile(blob, filename) {
  // edge浏览器不支持new File对象，所以用以下方法兼容
  blob.lastModifiedDate = new Date();
  blob.name = filename;
  // console.log('blob:', blob);
  return blob;
}

function getFileName(url) {
  // 获取到文件名
  let pos = url.lastIndexOf("/"); // 查找最后一个/的位置
  return url.substring(pos + 1); // 截取最后一个/位置到字符长度，也就是截取文件名
}

export default {
  // encryption: encryption,
  resize: resize,
  compressImg: compressImg,

  convertBase64UrlToBlob: convertBase64UrlToBlob,
  compressImage: compressImage,

  imgUrlToFile: imgUrlToFile,
}


//webpack2不允许混用import和module.exports
// module.exports = {
//   imgUrlToFile: imgUrlToFile,
//   compressImage: compressImage,
// }


// WEBPACK FOOTER //
// ./src/utils/util.js